/* ============================================================
   PDP v3 – komplettes Redesign (Logik).
   Aktivierung übernimmt der Controller in pdp-v2.js (Flag "pdp-version").
   Dieses Script initialisiert v3, sobald <html class="pdp-v3-on"> gesetzt ist
   (oder sofort, falls schon gesetzt).
   ============================================================ */
(function () {
  'use strict';

  function whenActive(cb) {
    if (document.documentElement.classList.contains('pdp-v3-on')) return cb();
    document.addEventListener('pdp:version', function (e) {
      if (e.detail === 'v3') cb();
    });
  }

  function ready(cb) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cb);
    else cb();
  }

  ready(function () {
    var root = document.querySelector('[data-pdp3]');
    if (!root) return;

    whenActive(function () {
      if (root.dataset.p3Init === '1') return;
      root.dataset.p3Init = '1';

      var moneyFormat = root.getAttribute('data-money-format') || '€{{amount}}';
      function formatMoney(cents) {
        var d = (cents / 100).toFixed(2).replace('.', ',');
        return moneyFormat
          .replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/g, d)
          .replace(/<[^>]*>/g, '').trim() || ('€' + d);
      }
      function priceHTML(cents) {
        return formatMoney(cents).replace(/,(\d+)/, '<sup class="p3-cents">$1</sup>');
      }

      var dataEl = root.querySelector('[data-p3-data]');
      var data = { options: [], variants: [] };
      try { data = JSON.parse(dataEl.textContent); } catch (e) {}

      // ---------- Varianten-State ----------
      var selected = [];
      root.querySelectorAll('[data-p3-option]').forEach(function (opt, i) {
        var active = opt.querySelector('.is-active');
        selected[i] = active ? active.getAttribute('data-p3-value') : null;
      });

      function currentVariant() {
        return data.variants.find(function (v) {
          return v.options.every(function (val, i) { return selected[i] === null || val === selected[i]; });
        }) || null;
      }

      var priceEl = root.querySelector('[data-p3-price]');
      var compareEl = root.querySelector('[data-p3-compare]');
      var atc = root.querySelector('[data-p3-atc]');
      var atcLabel = root.querySelector('[data-p3-atc-label]');
      var delivery = root.querySelector('[data-p3-delivery]');
      var stickyPrice = root.querySelector('[data-p3-sticky-price]');

      function applyVariant() {
        var v = currentVariant();
        if (!v) return;
        root.setAttribute('data-selected-variant', v.id);
        if (priceEl) priceEl.innerHTML = priceHTML(v.price);
        if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare > v.price) { compareEl.textContent = formatMoney(v.compare); compareEl.classList.remove('hidden'); }
          else compareEl.classList.add('hidden');
        }
        if (atc) {
          atc.disabled = !v.available;
          if (atcLabel) atcLabel.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        }
        if (delivery) delivery.hidden = !v.available;
        if (v.mediaPos > 0) goTo(v.mediaPos - 1);
      }

      root.querySelectorAll('[data-p3-option]').forEach(function (opt, i) {
        var label = opt.querySelector('[data-p3-option-value]');
        opt.querySelectorAll('[data-p3-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            opt.querySelectorAll('.is-active').forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            selected[i] = btn.getAttribute('data-p3-value');
            if (label) label.textContent = selected[i];
            applyVariant();
          });
        });
      });

      // ---------- Skeleton: Bilder als geladen markieren ----------
      root.querySelectorAll('.p3-gallery__slide, .p3-thumb, .p3-block__img').forEach(function (wrap) {
        var im = wrap.querySelector('img');
        if (!im) { wrap.classList.add('is-loaded'); return; }
        function done() { wrap.classList.add('is-loaded'); syncTrackHeight(); }
        if (im.complete && im.naturalWidth) done();
        else { im.addEventListener('load', done); im.addEventListener('error', done); }
      });

      // ---------- Galerie ----------
      var track = root.querySelector('[data-p3-track]');
      var dots = root.querySelectorAll('[data-p3-dots] span');
      var thumbs = root.querySelectorAll('[data-p3-thumb]');
      var activeSlide = 0;

      // Track-Höhe = Höhe des aktiven Slides (gemischte Ratios: Variant 3/2, Rest 1/1)
      function syncTrackHeight() {
        if (!track) return;
        var slide = track.querySelector('[data-p3-slide="' + activeSlide + '"]');
        if (slide && slide.offsetHeight > 40) track.style.height = slide.offsetHeight + 'px';
      }

      function goTo(i) {
        if (!track) return;
        var slide = track.querySelector('[data-p3-slide="' + i + '"]');
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      function markActive(i) {
        activeSlide = i;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
        syncTrackHeight();
      }
      if (track) {
        var st;
        track.addEventListener('scroll', function () {
          clearTimeout(st);
          st = setTimeout(function () {
            markActive(Math.round(track.scrollLeft / track.clientWidth));
          }, 80);
        }, { passive: true });
        window.addEventListener('resize', syncTrackHeight, { passive: true });
        setTimeout(syncTrackHeight, 250);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-p3-thumb'), 10)); });
      });

      // ---------- Add to Cart (Theme-Slide-Cart via ajaxProduct:added) ----------
      // Exakt das bewährte Muster der Gift Collection: ajaxProduct:added + cart:refresh/build
      // + Klick auf den Theme-Drawer-Trigger (öffnet den AMP-Slide-Cart zuverlässig).
      function openSlideCart() {
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build'));
        } catch (e) {}
        var trigger = document.querySelector('.js-drawer-open-cart, [aria-controls="CartDrawer"]');
        if (trigger) trigger.click();
      }
      function addToCart(btn) {
        var v = currentVariant();
        if (!v || !v.available) return;
        var orig = btn.textContent;
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
          body: 'id=' + v.id + '&quantity=1'
        })
          .then(function (r) { return r.json(); })
          .then(function (item) {
            btn.disabled = false;
            if (item && item.status && item.status !== 200) {
              btn.textContent = 'Nicht verfügbar';
              setTimeout(function () { btn.textContent = orig; }, 2500);
              return;
            }
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item, addToCartBtn: btn } }));
            openSlideCart();
          })
          .catch(function () { btn.disabled = false; btn.textContent = 'Fehler – erneut versuchen'; setTimeout(function () { btn.textContent = orig; }, 2500); });
      }
      if (atc) atc.addEventListener('click', function () { addToCart(atc); });

      // ---------- Zurück zur Collection ----------
      // Quellen (Priorität): 1) URL-Pfad /collections/x/products/y
      //                      2) sessionStorage (von der Gift-Collection gesetzt)
      //                      3) Referrer /collections/x (same-origin)
      (function () {
        var col = null;
        var m = location.pathname.match(/^\/collections\/([^\/]+)\/products\//);
        if (m) col = { url: '/collections/' + m[1], handle: m[1] };
        if (!col) {
          try {
            var st = JSON.parse(sessionStorage.getItem('sp:lastCollection') || 'null');
            if (st && st.url) col = st;
          } catch (e) {}
        }
        if (!col && document.referrer) {
          try {
            var r = new URL(document.referrer);
            var rm = r.hostname === location.hostname && r.pathname.match(/^\/collections\/([^\/]+)\/?$/);
            if (rm) col = { url: r.pathname, handle: rm[1] };
          } catch (e) {}
        }
        if (!col) return;
        var title = col.title;
        if (!title && col.handle) {
          title = col.handle.replace(/-/g, ' ').replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
        }
        var label = 'Zurück zu „' + title + '“';
        [['[data-p3-back]', '[data-p3-back-label]'], ['[data-p3-back-discover]', '[data-p3-back-label2]']].forEach(function (pair) {
          var a = root.querySelector(pair[0]);
          var l = root.querySelector(pair[1]);
          if (a) { a.href = col.url; a.hidden = false; }
          if (l) l.textContent = label;
        });
      })();

      // ---------- Reviews-Modal (produkt-spezifisches Judge.me-Widget) ----------
      (function () {
        var jump = root.querySelector('[data-p3-reviews-jump]');
        if (!jump) return;
        function openRev() { document.documentElement.classList.add('pdp-v3-rev-open'); document.body.style.overflow = 'hidden'; }
        function closeRev() { document.documentElement.classList.remove('pdp-v3-rev-open'); document.body.style.overflow = ''; }
        jump.addEventListener('click', openRev);
        root.querySelectorAll('[data-p3-rev-close]').forEach(function (c) { c.addEventListener('click', closeRev); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeRev(); });
      })();

      // ---------- Promo-Code: Tap-to-Copy (KEIN Auto-Apply – Kunde gibt ihn an der Kasse ein) ----------
      var copyBtn = root.querySelector('[data-p3-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = copyBtn.getAttribute('data-p3-copy');
          function done() {
            copyBtn.classList.add('is-copied');
            var orig = copyBtn.childNodes[0].textContent;
            copyBtn.childNodes[0].textContent = 'Kopiert ✓';
            setTimeout(function () {
              copyBtn.classList.remove('is-copied');
              copyBtn.childNodes[0].textContent = orig;
            }, 1800);
          }
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).then(done).catch(function () { fallback(); });
          } else fallback();
          function fallback() {
            var ta = document.createElement('textarea');
            ta.value = code; ta.style.position = 'fixed'; ta.style.opacity = '0';
            document.body.appendChild(ta); ta.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
            document.body.removeChild(ta);
          }
        });
      }

      // ---------- Sticky ----------
      var sticky = root.querySelector('[data-p3-sticky]');
      if (sticky && atc) {
        var stickyCta = sticky.querySelector('[data-p3-sticky-cta]');
        if (stickyCta) stickyCta.addEventListener('click', function () { addToCart(stickyCta); });
        var anchorDocBottom = 600;
        function measure() {
          var r = atc.getBoundingClientRect();
          anchorDocBottom = Math.max(200, r.bottom + window.scrollY);
        }
        function updateSticky() {
          sticky.classList.toggle('is-visible', window.scrollY > anchorDocBottom + 60);
        }
        setTimeout(measure, 300);
        window.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', function () { measure(); updateSticky(); }, { passive: true });
        updateSticky();
      }
    });
  });
})();
